export class AcceptedSearchTermSpec {
    constructor(
        public name: string,
        public value: string
    ) { }
}
